<label [attr.for]="inputId"
       #label
       class="block cursor-pointer"
       [ngClass]="[centerText ? '' : 'p-t-3 p-b-3', isBasketContext ? 'bg-col-w p-t-0 p-b-0' : 'bg-col-51 p-l p-r']">
    <div class="flex p-l-1"
         [ngClass]="centerText ? 'flex-middle' : 'flex-top'">
        <input #input
               class="visually-hidden"
               [id]="inputId"
               type="radio"
               [required]="required"
               [checked]="checked"
               [attr.value]="value"
               [disabled]="disabled"
               [attr.name]="name"
               [attr.aria-label]="ariaLabel || null"
               [attr.aria-labelledby]="ariaLabelledby"
               (change)="onInputChange($event)">

        <i [ngClass]="checked ? 'icon-radio-on' : 'icon-radio-off'"
           class="col-1 radio__icon"></i>

        <div class="radio__content flex-grow m-l-3">
            <!-- Use either radioBody to have own stylijng or regular content to have default one -->
            <div class="flex flex-grow"
                 [ngClass]="centerText ? 'flex-middle' : 'flex-top'">
                <p class="p1 flex-grow">
                    <ng-content select="[radioTitle]"></ng-content>
                </p>
                <p class="s2">
                    <ng-content select="[radioAside]"></ng-content>
                </p>
            </div>
            <p class="p2 col-11">
                <ng-content select="[radioSubtitle]"></ng-content>
            </p>
        </div>
    </div>
    <div class="p2 col-11">
        <ng-content select="[radioBottom]"></ng-content>
    </div>
</label>